<div class="input-form input-text-file">
  <div class="input-file btn-default btn-invert">
        <img src="assets/images/icons/fotografia.svg">
            <label for="archivo">Seleccionar archivo
                      <input type="file" #file [multiple]="(maxFiles > 1)" (change)="onFileChange($event)" class="hide_file"/>
                    </label>
                  </div>
                </div>              
              <div class="row error" *ngIf="errors.length > 0">    
                  <ul>
                    <li *ngFor="let err of errors">{{err}}</li>
                  </ul>
                </div>

               <div *ngIf="files.length > 0">    
                    <ul>
                      <li *ngFor="let file of files">Fichero seleccionado: {{file.name}}</li>                      
                    </ul>
                    <ul>
                        <a (click)="QuitarImagen()" >Quitar imagen</a>
                      </ul>
              </div>